module.exports = "/public/images/afafb052254d10d92bd78ccd000226b7.png";